<template>
  <div class="row">
    <div class="col">
      <h5>Marketing Dashboard</h5>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col">
      <p>As a Locator ONLY user you do not have access to these features. If you would like the ability to search for
        ADAS MAP shops and get access to their required calibrations and potential revenue opportunities, please contact
        your OPUS representative.</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MarketingDashboardView'
}
</script>
<style lang="scss" scoped></style>
